import { AccountProductEnum } from '@varo/graphql-schema-types';
import { Stack, useRouter } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import Button from 'shared/components/vxl/Button/Button';
import { usePressableAnalytics } from 'shared/hooks/analytics/usePressableAnalytics';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import ActionScreen from 'shared/patterns/vxl/ActionScreen/ActionScreen';
import theme from 'shared/styles/theme';

import MoneyInBody from './MoneyInBody';

const MoneyInScreen = () => {
  const router = useRouter();
  const { top } = useSafeAreaInsets();
  const { t: translate } = useTranslation('believe');

  useViewDidFocusScreenAnalyticsEvent({
    key: 'moneyIn',
  });

  const handleSkipNowAnalytics = usePressableAnalytics({
    analyticsId: 'skipNow',
  });

  const handleMoveMoneyAnalytics = usePressableAnalytics({
    analyticsId: 'moveMoney',
  });

  const handlePress = () => {
    handleMoveMoneyAnalytics();
    router.replace({
      pathname: '/move-money/transfer/transfer-money',
      params: {
        typeOfAccount: AccountProductEnum.ChargeCard,
      },
    });
  };

  return (
    <View style={[styles.container, { paddingTop: top }]}>
      <Stack.Screen
        options={{
          headerShown: false,
        }}
      />
      <View style={styles.skipForNowSection}>
        <View>
          <Button
            label={translate('application.moveMoney.skipForNow')}
            type="TEXT"
            onPress={() => {
              handleSkipNowAnalytics();
              router.replace('/');
            }}
          />
        </View>
      </View>
      <ActionScreen
        titleText={translate('application.moveMoney.title')}
        titleTextStyle="extra-large"
        visual="BELIEVE_A"
        visualAccessibilityLabel="Believe Image"
        bodyContent={<MoneyInBody />}
        primaryButton={{
          label: translate('application.moveMoney.moveMoney'),
          onPress: () => handlePress(),
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
  skipForNowSection: {
    alignItems: 'flex-end',
    marginHorizontal: theme.spacing.l,
    marginTop: theme.spacing.s,
  },
});

export default MoneyInScreen;
